import { JobRequestStatus as APIJobRequestStatus } from 'api/domain/entities/JobRequest';

export type JobRequestStatus = APIJobRequestStatus;
export const JobRequestStatus = APIJobRequestStatus;
